import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Col, Modal, Row } from "react-bootstrap";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import {
  fitnessmenuenablecreate,
  fitnessmenuenabledelete,
  fitnessmenuenablelist,
  fitnessmenuenableupdate,
  funderlist,
} from "../../../../services/master";
import Select from "react-select";
import { schoolactivelist } from "../../../../services/superadmin";

export const StudentFitnessMenuEnable = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [show, setShow] = useState(false);
  const [clsid, setId] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");

  const sorting = useMemo(() => {
    return ["asc", "desc"];
  }, []);

  const columnDefs = [
    {
      headerName: "School",
      field: "school_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    // {
    //     headerName: "Status",
    //     field: "is_active",
    //     resizable: true,
    //     cellRenderer: function (params) {
    //         return (
    //             <div className="text-center">
    //                 <label className="custom-switch mb-0">
    //                     <input
    //                         type="checkbox"
    //                         name="custom-switch-checkbox"
    //                         className="custom-switch-input"
    //                         checked={params.value === 1 ? true : false}
    //                         onChange={() => deleteclass(params)}
    //                     />

    //                     <span className="custom-switch-indicator"></span>
    //                 </label>
    //             </div>
    //         );
    //     },
    // },
    {
      headerName: "Actions",
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => deleteclass(params)}
              title="Delete"
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
  ];

  const columnFDefs = [
    {
      headerName: "Funder",
      field: "funder_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    // {
    //     headerName: "Status",
    //     field: "is_active",
    //     resizable: true,
    //     cellRenderer: function (params) {
    //         return (
    //             <div className="text-center">
    //                 <label className="custom-switch mb-0">
    //                     <input
    //                         type="checkbox"
    //                         name="custom-switch-checkbox"
    //                         className="custom-switch-input"
    //                         checked={params.value === 1 ? true : false}
    //                         onChange={() => deleteclass(params)}
    //                     />

    //                     <span className="custom-switch-indicator"></span>
    //                 </label>
    //             </div>
    //         );
    //     },
    // },
    {
      headerName: "Actions",
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => deleteclass(params)}
              title="Delete"
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash fa-lg"></i>
            </a>
          </div>
        );
      },
    },
  ];

  function viewclass(aid) {
    setShow(true);
    // classdetails(aid).then((response) => {
    //     if (response.status === true) {
    //         setId(response.data.id)
    //         dotracking("edit button in class for "+ response.data.class + " (" + aid + ") $$ " + trackobj.classlistheading)

    //     }
    // })
  }

  function handleshow() {
    setId(0);
    setSchool([]);
    setErrorMsg("");
    setShow(true);
  }
  function handleclose() {
    setShow(false);
    setId(0);
    setSchool([]);
    setErrorMsg("");
  }

  function deleteclass(list) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (urllink === "schoolfitness") {
          dotracking(
            "delete icon in Student Fitness - School list for " +
              list.data.school_name +
              " (" +
              list.data.schoolhead_or_funder_id +
              ") $$ " +
              trackobj.schfitnessheading
          );
        } else if (urllink === "funderfitness") {
          dotracking(
            "delete icon in Student Fitness - Funder list for " +
              list.data.funder_name +
              " (" +
              list.data.schoolhead_or_funder_id +
              ") $$ " +
              trackobj.funfitnessheading
          );
        }
       
        fitnessmenuenabledelete(list.data.id).then((response) => {
            if (response.status === true) {
                listall(urllink);
                toast.success(response.message)
            }
        })
      }
    });
  }
  const [urllink, setUrlLink] = useState("");

  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    setUrlLink(link[1]);
    listall(link[1]);
  }, [window.location.href]);

  function listall(ltype) {
    setFilterProduct([]);
    if (ltype == "schoolfitness") {
      schoolactivelist().then((response) => {
        if (response.status === true) {
          if (response.data.details.length !== 0) {
            let arr = [];
            for (let i = 0; i < response.data.details.length; i++) {
              arr.push({
                value: response.data.details[i].id,
                label:
                  response.data.details[i].school_unique_no +
                  " - " +
                  response.data.details[i].school_name,
              });
            }
            setSchList(arr);
          }
        }
      });
      fitnessmenuenablelist(1).then((response) => {
        if (response.status === true) {
          //   setFilterProduct(response.data);
          let arr = [];
          arr = response.data.map((item) => ({
            ...item,
            school_name: item.school_unique_no + " - " + item.school_name,
          }));
          setFilterProduct(arr);
        }
      });
    } else if (ltype == "funderfitness") {
      funderlist().then((response) => {
        if (response.status === true) {
          if (response.data.funders_list.length !== 0) {
            let arr = [];
            for (let i = 0; i < response.data.funders_list.length; i++) {
              arr.push({
                value: response.data.funders_list[i].id,
                label: response.data.funders_list[i].funder_name,
              });
            }
            setSchList(arr);
          }
        }
      });
      fitnessmenuenablelist(2).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data);
        }
      });
    }
  }

  function submitclass(e) {
    e.preventDefault();
    setErrorMsg("");
    if (schid !== "") {
      if (clsid === 0) {
        let schl = [];
        let scname = "";
        if (Array.isArray(schid)) {
          schl = schid.map((item) => item.value);
          const labels = schid.map((item) => item.label); // e.g., ['abc', 'cde', ...]
          scname = labels.join(",");
        }
        const temp = new FormData();
        // temp.append("schoolhead_or_funder_id",JSON.stringify(schl));
        schl.forEach((id) => {
          temp.append("schoolhead_or_funder_id[]", id); // <-- pass each ID
        });
        if (urllink === "schoolfitness") {
          temp.append("type", 1);
          dotracking(
            "add button in Student Fitness - School list for " +
              scname +
              " $$ " +
              trackobj.schfitnessheading
          );
        } else if (urllink === "funderfitness") {
          temp.append("type", 2);
          dotracking(
            "add button in Student Fitness - Funder list for " +
              scname +
              " $$ " +
              trackobj.funfitnessheading
          );
        }
        fitnessmenuenablecreate(temp).then((response) => {
          if (response.status === true) {
            handleclose();
            listall(urllink);
            toast.success(response.message);
          }
        });
      } else if (clsid !== 0) {
        const temp = new FormData();
        temp.append("id", clsid);
        temp.append("schoolhead_or_funder_id", schid.value);
        // if(urllink === "schoolfitness"){
        //     temp.append("type", 1);
        //     dotracking("update button in Student Fitness - School list for " + schid + " $$ " + trackobj.schfitnessheading)
        // }else if(urllink === "funderfitness"){
        //     temp.append("type", 2);
        //     dotracking("update button in Student Fitness - Funder list for " + schid + " $$ " + trackobj.funfitnessheading)
        // }
        // fitnessmenuenableupdate(temp).then((response) => {
        //     if (response.status === true) {
        //         handleclose();
        //         listall();
        //         toast.success(response.message);
        //     }
        // })
      }
    } else {
      if (urllink === "schoolfitness") {
        setErrorMsg("Please Select School");
      } else if (urllink === "funderfitness") {
        setErrorMsg("Please Enter Funder");
      }
    }
  }
  const [schlist, setSchList] = useState([]);
  const [schid, setSchool] = useState([]);

  function handleSch(e) {
    if (e != null) {
      setSchool(e);
    } else {
      setSchool([]);
    }
  }
  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">
            {urllink === "schoolfitness"
              ? "Student Fitness - School"
              : urllink === "funderfitness"
              ? "Student Fitness - Funder"
              : ""}{" "}
            Lists
          </h4>
        </div>
        <ol className="breadcrumb">
          {localStorage.getItem("Subrole") === "1" && (
            <li className="breadcrumb-item">
              <a>Setup</a>
            </li>
          )}
          {localStorage.getItem("Subrole") !== "1" && (
            <li className="breadcrumb-item">
              <a>Master</a>
            </li>
          )}
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "schoolfitness"
              ? "Student Fitness - School"
              : urllink === "funderfitness"
              ? "Student Fitness - Funder"
              : ""}{" "}
            Lists
          </li>
        </ol>
      </div>
      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <div className="text-right">
                <a className="btn btn-success" onClick={handleshow}>
                  <i className="fa fa-plus"></i> Add{" "}
                  {urllink === "schoolfitness"
                    ? " School"
                    : urllink === "funderfitness"
                    ? " Funder"
                    : ""}
                </a>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={
                    urllink === "schoolfitness" ? columnDefs : columnFDefs
                  }
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={sorting}
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                  domLayout="autoWidth"
                  onGridReady={(params) => {
                    params.api.sizeColumnsToFit();
                  }}
                />
              </div>

              <Modal show={show} size="lg" onHide={handleclose}>
                <Modal.Header>
                  {clsid !== 0 && (
                    <h4>
                      {" "}
                      {urllink === "schoolfitness"
                        ? "School "
                        : urllink === "funderfitness"
                        ? "Funder "
                        : ""}{" "}
                      Details
                    </h4>
                  )}
                  {clsid === 0 && (
                    <h4>
                      {" "}
                      Add{" "}
                      {urllink === "schoolfitness"
                        ? " School"
                        : urllink === "funderfitness"
                        ? " Funder"
                        : ""}
                    </h4>
                  )}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Select{" "}
                          {urllink === "schoolfitness"
                            ? "School"
                            : urllink === "funderfitness"
                            ? "Funder"
                            : ""}{" "}
                          <span className="errortext"> *</span>
                        </label>
                        <Select
                          className="dropdown"
                          placeholder={
                            urllink === "schoolfitness"
                              ? "Select School"
                              : urllink === "funderfitness"
                              ? "Select Funder"
                              : ""
                          }
                          value={schid}
                          options={schlist}
                          onChange={handleSch}
                          isSearchable={true}
                          isClearable
                          isMulti
                          hidden
                        />
                      </div>
                    </Col>

                    {/* <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Status <span className="errortext"> *</span>
                        </label>

                        <div className="row" onChange={Selectstatus}>
                          <div className="col-md-6">
                            <label className="custom-control custom-radio custom-control-md">
                              <input
                                type="radio"
                                className="reg-chk"
                                id="active"
                                value="1"
                                checked={status === "1"}
                              />{" "}
                              Active
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label className="custom-control custom-radio custom-control-md">
                              <input
                                type="radio"
                                className="reg-chk"
                                id="active"
                                value="0"
                                checked={status === "0"}
                              />{" "}
                              Inactive
                            </label>
                          </div>
                        </div>
                      </div>
                    </Col> */}
                    {errorMsg !== "" && (
                      <span className="errortext">{errorMsg}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={handleclose}>
                    Close
                  </a>
                  {clsid !== 0 && (
                    <a className="btn btn-success" onClick={submitclass}>
                      Update
                    </a>
                  )}
                  {clsid === 0 && (
                    <a className="btn btn-success" onClick={submitclass}>
                      Add
                    </a>
                  )}
                </Modal.Footer>
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
